export default __webpack_public_path__ + "static/media/power-point.c8d59971.png";